import Login from "../domain/Authentication/Login/Login";
import RegisterStep1 from "../domain/Authentication/Register/RegisterStep1/RegisterStep1";
import RegisterStep2 from "../domain/Authentication/Register/RegisterStep2/RegisterStep2";
import RegisterStep3 from "../domain/Authentication/Register/RegisterStep3/RegisterStep3";
import ResetPasswordConfirmation from "../domain/Authentication/ResetPasswordConfirmation/ResetPasswordConfirmation";
import TermsAndConditions from "../domain/Authentication/TermsAndConditions/TermsAndConditions";
import ResetPassword from "../domain/Authentication/ResetPassword/ResetPassword";
import InvitationResetPassword from "../domain/Authentication/InvitationResetPassword/InvitationResetPassword";
import ListServices from "../domain/Services/ListServices/ListServices";
import AddService from "../domain/Services/AddService/AddService";
import EditService from "../domain/Services/EditService/EditService";
import HandleMyService from "../domain/Services/HanldeMyService/HandleMyService";
import AddUser from "../domain/Users/AddUser/AddUser";
import EditUser from "../domain/Users/EditUser/EditUser";
import ListUsers from "../domain/Users/ListUsers/ListUsers";
import MyAccount from "../domain/Users/MyAccount/MyAccount";
import HandleAnalytics from "../domain/Analytics/HandleAnalytics/HandleAnalytics";
import Logout from "../domain/Authentication/Logout/Logout";
import HandleMyOrganisation from "../domain/Organisations/HanldeMyOrganisation/HandleMyOrganisation";
import ListOrganisations from "../domain/Organisations/ListOrganisations/ListOrganisations";
import AddOrganisation from "../domain/Organisations/AddOrganisation/AddOrganisation";
import EditOrganisation from "../domain/Organisations/EditOrganisation/EditOrganisation";
import TaxonomiesDashboard from "../domain/Taxonomies/TaxonomiesDashboard/TaxonomiesDashboard";
import EditTaxonomy from "../domain/Taxonomies/EditTaxonomy/EditTaxonomy";
import AddTaxonomy from "../domain/Taxonomies/AddTaxonomy/AddTaxonomy";
import ReverificationChecklist from "../domain/Utility/ReverificationChecklist/ReverificationChecklist";

export const anonymousRoutes = [
  { path: "/", component: Login },
  { path: "/register/step-1", component: RegisterStep1 },
  { path: "/register/step-2", component: RegisterStep2 },
  { path: "/register/step-3", component: RegisterStep3 },
  { path: "/password", component: ResetPassword },
  { path: "/invitation", component: InvitationResetPassword },
  { path: "/password/reset", component: ResetPasswordConfirmation },
  { path: "/terms-and-conditions", component: TermsAndConditions },
];

export const protectedRoutes = [
  { path: "/services", component: ListServices },
  { path: "/services/add", component: AddService },
  { path: "/services/add/:step", component: AddService },
  { path: "/services/:serviceId/edit", component: EditService },
  { path: "/services/:serviceId/edit/:step", component: EditService },
  { path: "/service", component: HandleMyService },
  { path: "/users", component: ListUsers },
  { path: "/users/add", component: AddUser },
  { path: "/users/:userId/edit", component: EditUser },
  { path: "/account", component: MyAccount },
  { path: "/analytics", component: HandleAnalytics },
  { path: "/logout", component: Logout, routeProps: { withLayout: false } },
  { path: "/organisation", component: HandleMyOrganisation },
  { path: "/organisations", component: ListOrganisations },
  { path: "/organisations/add", component: AddOrganisation },
  { path: "/organisations/add/:step", component: AddOrganisation },
  { path: "/organisations/:organisationId/edit", component: EditOrganisation },
  { path: "/organisations/:organisationId/edit/:step", component: EditOrganisation },
  { path: "/taxonomies", component: TaxonomiesDashboard },
  {
    path: "/taxonomies/:vocabularyName/:vocabularyId/:termId/edit",
    component: EditTaxonomy,
  },
  { path: "/taxonomies/:vocabularyName/:vocabularyId/add", component: AddTaxonomy },
  { path: "/reverification-checklist", component: ReverificationChecklist },
];
